var _defs, _path, _polyline, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcVisa = function SvgIcVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "11.206 16.337 57.87 18.622",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005098;}.cls-2{fill:#f7a600;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.64,16.56,23.05,28.92l-.49-2.51a14.38,14.38,0,0,0-6.48-7.57l4.19,15.82h4.95l7.37-18.1h-5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.56 34.67 34.49 16.54 39.17 16.54 36.24 34.67 31.56 34.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.22,17A11.52,11.52,0,0,0,49,16.23c-4.64,0-7.89,2.46-7.92,6,0,2.62,2.33,4.07,4.1,4.94s2.44,1.45,2.43,2.25c0,1.21-1.46,1.76-2.8,1.76a9.3,9.3,0,0,1-4.4-.95l-.61-.29L39.17,34a14.25,14.25,0,0,0,5.22,1c4.92,0,8.11-2.43,8.15-6.19,0-2.07-1.23-3.64-3.94-4.93C47,23,46,22.42,46,21.57S46.83,20,48.66,20a8.17,8.17,0,0,1,3.51.7l.41.21L53.22,17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.22,16.56H61.6a2.32,2.32,0,0,0-2.45,1.5L52.2,34.67h4.92l1-2.72h6c.15.63.58,2.71.58,2.71H69L65.22,16.56M59.45,28.24c.39-1,1.87-5.06,1.87-5.06s.38-1.05.62-1.73L62.25,23s.9,4.33,1.09,5.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.81,16.55H11.26l0,.31c5.87,1.5,9.74,5.19,11.35,9.55l-1.63-8.33A2,2,0,0,0,18.81,16.55Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_visa.a069b093.svg";
export { ForwardRef as ReactComponent };